"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var id_1 = __importDefault(require("../EditorState/id"));

var fromRaw = function fromRaw(raw) {
  var state = {
    value: [],
    entityMap: raw.entityMap
  };
  var ignore = true;
  var text = raw.text;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = text[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var char = _step.value;

      if (char === '[') {
        ignore = false;
        var val = {
          type: 'block-start',
          styles: [],
          blockKey: id_1.default()
        };
        state.value.push(val);
      } else if (char === ']') {
        ignore = true;
        var _val = {
          type: 'block-end'
        };
        state.value.push(_val);
      } else if (ignore === false) {
        var _val2 = {
          char: char,
          styles: []
        };
        state.value.push(_val2);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  raw.ranges.forEach(function (_a) {
    var offset = _a.offset,
        length = _a.length,
        entityKey = _a.entity,
        charData = __rest(_a, ["offset", "length", "entity"]);

    for (var i = offset; i < offset + length; i++) {
      var value = state.value[i];

      if (value.type == null || value.type === 'block-start') {
        var entity = entityKey != null && state.entityMap[entityKey] ? entityKey : null;
        var newValue = Object.assign({}, value, charData);

        if (entity != null) {
          newValue.entity = entity;
        }

        state.value[i] = newValue;
      }
    }
  });
  return state;
};

exports.default = fromRaw;